import { Warrant } from 'data/warrant/warrant.types';
import { WARRANT_RESSTATE } from '../warrant-enums';
import { COMMON_GRID_ACTION } from '../../../shared/commonGrid/grid-enums';

const VALID_STATES_FOR_START: string[] = [
  WARRANT_RESSTATE.Stopped,
  WARRANT_RESSTATE.Expired,
];

const VALID_STATES_FOR_STOP: string[] = [
  WARRANT_RESSTATE.Active,
  WARRANT_RESSTATE.Paused,
];

const VALID_STATES_FOR_RESCHEDULE: string[] = [
  WARRANT_RESSTATE.Stopped,
  WARRANT_RESSTATE.Expired,
  WARRANT_RESSTATE.Pending,
  WARRANT_RESSTATE.NotYetStarted,
];

const showActionMenuItem = (
  menuId: string,
  selectedWarrant: Warrant,
  isWarrantResumeActionEnabled: boolean,
  isWarrantPauseActionEnabled: boolean,
): boolean => {
  if (!selectedWarrant) return false;

  switch (menuId) {
    case COMMON_GRID_ACTION.Pause: {
      if (isWarrantPauseActionEnabled === true && selectedWarrant.state === WARRANT_RESSTATE.Active) {
        return true;
      }
      break;
    }
    case COMMON_GRID_ACTION.Resume: {
      if (isWarrantResumeActionEnabled === true && selectedWarrant.state === WARRANT_RESSTATE.Paused) {
        return true;
      }
      break;
    }
    case COMMON_GRID_ACTION.Start:
      return shouldDisplayAction(selectedWarrant, VALID_STATES_FOR_START);

    case COMMON_GRID_ACTION.Stop:
      return shouldDisplayAction(selectedWarrant, VALID_STATES_FOR_STOP);

    case COMMON_GRID_ACTION.Reschedule:
      return shouldDisplayAction(selectedWarrant, VALID_STATES_FOR_RESCHEDULE);

    case COMMON_GRID_ACTION.Edit: {
      if (selectedWarrant.state !== WARRANT_RESSTATE.Trash) {
        return true;
      }
      break;
    }
    case COMMON_GRID_ACTION.Trash: {
      if (selectedWarrant.state !== WARRANT_RESSTATE.Trash) {
        return true;
      }
      break;
    }
    case COMMON_GRID_ACTION.Delete: {
      if (selectedWarrant.state !== WARRANT_RESSTATE.Active) {
        return true;
      }
      break;
    }
    default: return true;
  }

  return false;
};

export default showActionMenuItem;

function shouldDisplayAction({ state, uniqueSubStates }: Warrant, validStates: string[]) {
  if (state == null) {
    return false;
  }

  if (state === WARRANT_RESSTATE.Mixed) {
    // MIXED is valid when all uniqueSubStates are valid too
    return uniqueSubStates?.every((subState) => validStates.includes(subState)) ?? false;
  }

  return validStates.includes(state);
}
